import React, { useState, useEffect } from 'react'
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import dayjs from 'dayjs';
import {
  Modal,
  Table,
  Tag,
  Button,
  Popconfirm,
  Input,
  Dropdown,
  Menu,
  Avatar
} from 'antd';
import {
 viewLeadAssignedAtom,
 notificationsAtom,
 userPrivilagesAtom
} from '../../../../atoms/Atoms';
import api from '../../../../api/api';
import { toFormattedLocalTime } from '../../../../functions';

function LeadAssignedModal() {
  const defaultData = {
    assigned: [],
    requested: [],
  };
  const userPrivilages = useRecoilValue(userPrivilagesAtom);
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [lead, setLead] = useRecoilState(viewLeadAssignedAtom);
  const [data, setData] = useState(defaultData);
  const [loading, setLoading] = useState(false);
  const [searchingUsers, setSearchingUsers] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [users, setUsers] = useState([]);
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);

  function getData() {
    setLoading(true);
    api.get(`leads/assigned?leadId=${lead?.id}`)
      .then((response) => {
        setLoading(false);
        if (response?.data?.error) {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        } else {
          setData(response.data.data);
        }
      })
      .catch((error) => {
        setLoading(false);
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error.message,
            error: true,
          },
        ]);
      });
  }

  function assign(user) {
    setLoading(true);
    api
      .post('leads/assign', { UserId: user.id, LeadSubmissionId: lead?.id })
      .then((response) => {
        setLoading(false);
        if (response?.data?.success) {
          setUsers([]);
          setSearchText('');
          setNotifications([
            ...notifications,
            {
              title: t('success'),
              description: response.data.message,
              error: false,
            },
          ]);
          getData();
        } else {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        }
      })
      .catch((error) => {
        setLoading(false);
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error.message,
            error: true,
          },
        ]);
      });
  }

  function searchUsers() {
    if (searchText?.length > 0) {
      setSearchingUsers(true);
      api
        .post('leads/closers/search', { Query: searchText, OrganizationReferralCode: lead?.referralCode })
        .then((response) => {
          setSearchingUsers(false);
          if (response?.data?.success) {
            setUsers(response.data.data.users);
          } else {
            setNotifications([
              ...notifications,
              {
                title: t('error'),
                description: response?.data?.error,
                error: true,
              },
            ]);
          }
        })
        .catch((error) => {
          setSearchingUsers(false);
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: error.message,
              error: true,
            },
          ]);
        });
    } else {
      setUsers([]);
    }
  }

  function remove(assignment) {
    let assignments = [...data?.assigned];
    for (let i = 0; i < assignments.length; i++) {
      if (assignments[i].id === assignment.id) {
        assignments[i].loading = true; 
      }
    }
    setData({
      ...data,
      assigned: assignments
    });
    api
      .post(
        'leads/remove',
        {
          LeadSubmissionId: assignment.leadSubmissionId,
          UserId: assignment.assignedToId
        }
      )
      .then((response) => {
        assignments = [...data?.assigned];
        for (let i = 0; i < assignments.length; i++) {
          if (assignments[i].id === assignment.id) {
            assignments[i].loading = false; 
          }
        }
        setData({
          ...data,
          assigned: assignments
        });
        if (response.data.message) {
          setNotifications([
            ...notifications,
            {
              title: t('success'),
              description: response.data.message,
              error: false,
            },
          ]);
        }
        if (response?.data?.error) {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        }
        getData();
      })
      .catch((error) => {
        assignments = [...data?.assigned];
        for (let i = 0; i < assignments.length; i++) {
          if (assignments[i].id === assignment.id) {
            assignments[i].loading = false; 
          }
        }
        setData({
          ...data,
          assigned: assignments
        });
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error.message,
            error: true,
          },
        ]);
      });
  }

  function updateRequest(leadRequest, approved) {
    let requests = [...data?.requested];
    for (let i = 0; i < requests.length; i++) {
      if (requests[i].id === leadRequest.id) {
        requests[i].loading = true; 
      }
    }
    setData({
      ...data,
      requested: requests
    });
    api
      .post(
        'leads/request/update',
        {
          LeadRequestId: leadRequest.id,
          Approved: approved
        }
      )
      .then((response) => {
        requests = [...data?.requested];
        for (let i = 0; i < requests.length; i++) {
          if (requests[i].id === leadRequest.id) {
            requests[i].loading = false; 
          }
        }
        setData({
          ...data,
          requested: requests
        });
        if (response.data.message) {
          setNotifications([
            ...notifications,
            {
              title: t('success'),
              description: response.data.message,
              error: false,
            },
          ]);
        }
        if (response?.data?.error) {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        }
        getData();
      })
      .catch((error) => {
        requests = [...data?.requested];
        for (let i = 0; i < requests.length; i++) {
          if (requests[i].id === leadRequest.id) {
            requests[i].loading = false; 
          }
        }
        setData({
          ...data,
          requested: requests
        });
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error.message,
            error: true,
          },
        ]);
      });
  }

  useEffect(() => {
    setData(defaultData);
    setSearchText('');
    setUsers([]);
    if (lead) {
      setOpen(true);
      getData();
    } else {
      setOpen(false);
    }
  }, [lead]);

  return (
    <Modal
      width="80%"
      open={open}
      onCancel={() => {
        setLead(null);
      }}
      footer={[]}
    >
      <div className="mt-6">
        <Dropdown
          trigger="click"
          placement="bottom"
          overlay={
            <Menu>
              {_.map(users, (u) => (
                <Popconfirm
                  title={t('assign_user_to_lead_prompt')}
                  okText={t('yes')}
                  cancelText={t('no')}
                  onConfirm={() => {
                    assign(u);
                    setSearchText('');
                    setUsers([]);
                  }}
                >
                  <Menu.Item
                    key={u.id}
                  >
                    <span>
                      <Avatar src={u.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                      {u.completeName}: {u.email}
                    </span>
                  </Menu.Item>
                </Popconfirm>
              ))}
            </Menu>
          }
        >
          <Input.Search
            placeholder={`${t('search_users')}...`}
            allowClear
            className="mt-4"
            disabled={loading}
            loading={searchingUsers}
            enterButton={t('search')}
            size="small"
            value={searchText}
            onChange={(obj) => {
              setSearchText(obj.target.value);
              if (obj.target.value.length === 0) {
                setUsers([]);
              }
            }}
            onClear={() => setUsers([])}
            onSearch={(val) => searchUsers()}
          />
        </Dropdown>
        <Table
          title={() => <strong>{t('assigned')}</strong>}
          pagination={false}
          loading={loading}
          bordered
          className="mt-2"
          size="small"
          dataSource={data?.assigned}
          columns={[
            {
              title: '',
              align: 'center',
              className: 'text-sm w-full md:hidden',
              render: (row) => (
                <div className="w-full space-y-2">
                  <p><span className="font-bold">{t('approved_on')}: </span>{row.createdAt ? toFormattedLocalTime(row.createdAt) : '-'}</p>
                  <p>
                    <span className="font-bold">{t('name')}: </span>
                    <>
                      {row?.assignedTo && (
                        <span>
                          <Avatar src={row?.assignedTo?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                          {row?.assignedTo?.completeName}
                        </span>
                      )}
                      {!row?.assignedTo && (
                        <span>-</span>
                      )}
                    </>
                  </p>
                  <p>
                    <span className="font-bold">{t('approved_by')}: </span>
                    <>
                      {row?.acceptedBy && (
                        <span>
                          <Avatar src={row?.acceptedBy?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                          {row?.acceptedBy?.completeName}
                        </span>
                      )}
                      {!row?.acceptedBy && (
                        <span>-</span>
                      )}
                    </>
                  </p>
                  <>
                    {(userPrivilages?.hasCloserAdminPrivilages || userPrivilages?.hasLeadManager) && (
                      <div className="space-x-2">
                        <Popconfirm
                          title={t('confirm_remove_assigned_user_prompt')}
                          okText={t('yes')}
                          cancelText={t('no')}
                          onConfirm={() => remove(row)}
                        >
                          <Button danger loading={row.loading} type="primary" size="small">{t('remove')}</Button>
                        </Popconfirm>
                      </div>
                    )}
                  </>
                </div>
              ),
            },
            {
              title: t('approved_on'),
              align: 'center',
              className: 'text-sm hidden md:table-cell',
              render: (row) => (
                <span>{row.createdAt ? toFormattedLocalTime(row.createdAt) : '-'}</span>
              ),
            },
            {
              title: t('name'),
              align: 'center',
              className: 'text-sm hidden md:table-cell',
              render: (row) => (
                <>
                  {row?.assignedTo && (
                    <span>
                      <Avatar src={row?.assignedTo?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                      {row?.assignedTo?.completeName}
                    </span>
                  )}
                  {!row?.assignedTo && (
                    <span>-</span>
                  )}
                </>
              ),
            },
            {
              title: t('approved_by'),
              align: 'center',
              className: 'text-sm hidden md:table-cell',
              render: (row) => (
                <>
                  {row?.acceptedBy && (
                    <span>
                      <Avatar src={row?.acceptedBy?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                      {row?.acceptedBy?.completeName}
                    </span>
                  )}
                  {!row?.acceptedBy && (
                    <span>-</span>
                  )}
                </>
              ),
            },
            {
              title: t('actions'),
              align: 'center',
              className: 'text-sm hidden md:table-cell',
              render: (row) => (
                <>
                  {(userPrivilages?.hasCloserAdminPrivilages || userPrivilages?.hasLeadManager) && (
                    <div className="space-x-2">
                      <Popconfirm
                        title={t('confirm_remove_assigned_user_prompt')}
                        okText={t('yes')}
                        cancelText={t('no')}
                        onConfirm={() => remove(row)}
                      >
                        <Button danger loading={row.loading} type="primary" size="small">{t('remove')}</Button>
                      </Popconfirm>
                    </div>
                  )}
                </>
              ),
            },
          ]}
        />
        <Table
          title={() => <strong>{t('requested')}</strong>}
          pagination={false}
          loading={loading}
          bordered
          className="mt-6"
          size="small"
          dataSource={data?.requested}
          columns={[
            {
              title: '',
              align: 'center',
              className: 'text-sm w-full md:hidden',
              render: (row) => (
                <div className="w-full space-y-2">
                  <p><span className="font-bold">{t('created_on')}: </span>{row.createdAt ? toFormattedLocalTime(row.createdAt) : '-'}</p>
                  <p>
                    <span className="font-bold">{t('requested_by')}: </span>
                    <>
                      {row?.requestor && (
                        <span>
                          <Avatar src={row?.requestor?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                          {row?.requestor?.completeName}
                        </span>
                      )}
                      {!row?.requestor && (
                        <span>-</span>
                      )}
                    </>
                  </p>
                  <>
                    {row.status === 0 && userPrivilages?.hasCloserAdminPrivilages && (
                      <div className="space-x-2">
                        <Popconfirm
                          title={t('confirm_reject_request_prompt')}
                          okText={t('yes')}
                          cancelText={t('no')}
                          onConfirm={() => updateRequest(row, false)}
                        >
                          <Button loading={row.loading} danger type="primary" size="small">{t('reject')}</Button>
                        </Popconfirm>
                        <Popconfirm
                          title={t('confirm_approve_request_prompt')}
                          okText={t('yes')}
                          cancelText={t('no')}
                          onConfirm={() => updateRequest(row, true)}
                        >
                          <Button loading={row.loading} type="primary" size="small">{t('approve')}</Button>
                        </Popconfirm>
                      </div>
                    )}
                    {row.status === 0 && !userPrivilages?.hasCloserAdminPrivilages && (
                      <Tag size="small">{t('pending')}</Tag>
                    )}
                    {row.status === 1 && (
                      <Tag color="green" size="small">{t('approved')}</Tag>
                    )}
                    {row.status === 2 && (
                      <Tag color="red" size="small">{t('rejected')}</Tag>
                    )}
                  </>
                </div>
              ),
            },
            {
              title: t('created_on'),
              align: 'center',
              className: 'text-sm hidden md:table-cell',
              render: (row) => (
                <span>{row.createdAt ? toFormattedLocalTime(row.createdAt) : '-'}</span>
              ),
            },
            {
              title: t('requested_by'),
              align: 'center',
              className: 'text-sm hidden md:table-cell',
              render: (row) => (
                <>
                  {row?.requestor && (
                    <span>
                      <Avatar src={row?.requestor?.avatar} className="bg-primaryColor h12 w-8 mr-2" />
                      {row?.requestor?.completeName}
                    </span>
                  )}
                  {!row?.requestor && (
                    <span>-</span>
                  )}
                </>
              ),
            },
            {
              title: t('status'),
              align: 'center',
              className: 'text-sm hidden md:table-cell',
              render: (row) => (
                <>
                  {row.status === 0 && userPrivilages?.hasCloserAdminPrivilages && (
                    <div className="space-x-2">
                      <Popconfirm
                        title={t('confirm_reject_request_prompt')}
                        okText={t('yes')}
                        cancelText={t('no')}
                        onConfirm={() => updateRequest(row, false)}
                      >
                        <Button loading={row.loading} danger type="primary" size="small">{t('reject')}</Button>
                      </Popconfirm>
                      <Popconfirm
                        title={t('confirm_approve_request_prompt')}
                        okText={t('yes')}
                        cancelText={t('no')}
                        onConfirm={() => updateRequest(row, true)}
                      >
                        <Button loading={row.loading} type="primary" size="small">{t('approve')}</Button>
                      </Popconfirm>
                    </div>
                  )}
                  {row.status === 0 && !userPrivilages?.hasCloserAdminPrivilages && (
                    <Tag size="small">{t('pending')}</Tag>
                  )}
                  {row.status === 1 && (
                    <Tag color="green" size="small">{t('approved')}</Tag>
                  )}
                  {row.status === 2 && (
                    <Tag color="red" size="small">{t('rejected')}</Tag>
                  )}
                </>
              ),
            },
          ]}
        />
      </div>
    </Modal>
  );
}

export default LeadAssignedModal;
